/**
 * Operations Types
 * Types for reconciliation, jobs, and alerts (FiadoSA admin)
 */

export interface ReconciliationStatus {
  type: string;
  lastRun: string;
  status: 'OK' | 'DISCREPANCY' | 'ERROR';
  difference: number;
}

export interface ReconciliationDashboard {
  statuses: ReconciliationStatus[];
  dailyVerification: { systemAmount: number; collectorAmount: number; difference: number; couponsCount: number };
  balanceVerification: { creditsChecked: number; withDifferences: number; status: 'OK' | 'DISCREPANCY' };
}

export interface JobStatus {
  name: string;
  frequency: string;
  scheduledTime: string;
  process: string;
  description: string;
  lastExecution: string | null;
  lastStatus: 'COMPLETED' | 'RUNNING' | 'FAILED' | 'PENDING';
  nextExecution: string | null;
}

export enum AlertSeverity {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  MEDIUM = 'MEDIUM',
  LOW = 'LOW',
}

export interface Alert {
  id: string;
  severity: AlertSeverity;
  type: string;
  title: string;
  description: string;
  createdAt: string;
  acknowledgedAt: string | null;
  acknowledgedBy: string | null;
}
